import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { captureError } from "./sentry";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // Fires once per settled query (after retries exhaust), even when React
    // Query keeps status="success" because cached data is present — the case
    // that otherwise silently swallows background-refetch failures under
    // staleTime: Infinity (e.g. useCommunityFeed). Capturing here covers
    // every query uniformly and avoids per-attempt amplification.
    onError: (error, query) => {
      console.error("[query]", query.queryKey, error);
      captureError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      console.error("[mutation]", mutation.options.mutationKey, error);
      captureError(error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
